// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"e1917bb2","366":"90f72232","397":"f38bd0d3","465":"2b5fc9c0","713":"9031b172"}[chunkId] + ".chunk.js";
};